import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LoadingService } from '@services/loading.service';
import { standardHttpOptions } from '@models';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { KigSettings, KIG_SETTINGS } from '../../../settings/kig-settings';
import { UserService } from '@services/user.service';
import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { IsalIrrigationPlanInfo } from '@models/Isal/isalIrrigationPlanInfo.model';


@Injectable()
export class IsalService {
  public standardHttpOptionsWithUser: any;

  private apiUrl: string;

  constructor(private http: HttpClient,
              private loadingService: LoadingService,
              private userService: UserService,
              @Inject(KIG_SETTINGS) private settings: KigSettings, ) {
    this.apiUrl = this.settings.apiUrl;
  }


  buildStandardHttpOptionsWithUser(username: string) {
    this.standardHttpOptionsWithUser = {
      withCredentials: true,
      headers: new HttpHeaders({
        ['Content-Type']: 'application/json',
        username
      })
    };
  }


  // TODO update Observable<any> to accurately reflect type of data received
  public getIsalInfo(euids: string[]): Observable<any> {
    //this.loadingService.setMessage('Search ISAL for data ...');
    return this.http.post(`${ this.apiUrl }/isal/getisaldata`, JSON.stringify(euids), standardHttpOptions).pipe(
      catchError(this.handleError),
    //  finalize(() => this.loadingService.clearMessage())
    );
  }


  public createIsalIrrigationPlan(irrigationPlanInfo: IsalIrrigationPlanInfo, username: string) {
    this.loadingService.setMessage('Creating ISAL irrigation plan ...');
    return this.http.post(`${ this.apiUrl }/isal/createirrigationplan/${username}`, JSON.stringify(irrigationPlanInfo), standardHttpOptions).pipe(
      map((response: Response) => response == null ? 'success' : response),
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }


  private handleError(error: any) {
    if (error.status === 404) {
      return of(null);
    }
    return throwError(() => error);
  }
}
